import { render, staticRenderFns } from "./RoomNumberControlPanel.vue?vue&type=template&id=13a531a6&scoped=true&"
import script from "./RoomNumberControlPanel.vue?vue&type=script&lang=js&"
export * from "./RoomNumberControlPanel.vue?vue&type=script&lang=js&"
import style0 from "./RoomNumberControlPanel.vue?vue&type=style&index=0&id=13a531a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a531a6",
  null
  
)

export default component.exports